type Props = {
  size: number;
  color?: string;
};

const Wifi = ({ size, color = '#868686' }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0001 3.19995C8.2564 3.19995 4.64914 4.60577 1.89265 7.13905C1.58767 7.41933 1.56765 7.89378 1.84793 8.19876C2.12822 8.50374 2.60267 8.52376 2.90765 8.24348C5.38733 5.9646 8.63235 4.69995 12.0001 4.69995C15.368 4.69995 18.613 5.9646 21.0927 8.24348C21.3976 8.52376 21.8721 8.50374 22.1524 8.19876C22.4327 7.89378 22.4126 7.41933 22.1077 7.13905C19.3512 4.60577 15.7439 3.19995 12.0001 3.19995Z"
        fill={color}
      />
      <path
        d="M6.12592 11.7288C7.72317 10.2471 9.82139 9.42373 12.0001 9.42373C14.1788 9.42373 16.277 10.2471 17.8742 11.7288C18.1779 12.0105 18.6525 11.9927 18.9342 11.6891C19.2159 11.3854 19.1981 10.9109 18.8944 10.6292C17.0198 8.89009 14.5572 7.92373 12.0001 7.92373C9.44302 7.92373 6.98041 8.89009 5.10577 10.6292C4.80211 10.9109 4.7843 11.3854 5.06601 11.6891C5.34772 11.9927 5.82226 12.0105 6.12592 11.7288Z"
        fill={color}
      />
      <path
        d="M11.9999 12.639C10.6224 12.639 9.29693 13.1646 8.29378 14.1085C7.99212 14.3924 7.97768 14.8671 8.26153 15.1687C8.54539 15.4704 9.02004 15.4848 9.3217 15.201C10.0466 14.5189 11.0045 14.139 11.9999 14.139C12.9952 14.139 13.9531 14.5189 14.678 15.201C14.9797 15.4848 15.4543 15.4704 15.7382 15.1687C16.022 14.8671 16.0076 14.3924 15.7059 14.1085C14.7028 13.1646 13.3773 12.639 11.9999 12.639Z"
        fill={color}
      />
      <path
        d="M14.25 18.75C14.25 19.9926 13.2426 21 12 21C10.7574 21 9.75 19.9926 9.75 18.75C9.75 17.5073 10.7574 16.5 12 16.5C13.2426 16.5 14.25 17.5073 14.25 18.75Z"
        fill={color}
      />
    </svg>
  );
};

export default Wifi;
